import * as api from '../../constants/api'
import callApi from '../http'

const completeRequestOrganization = async (body) => await callApi(api.COMPLETE_REQUEST_ORGANIZATION, body)

const fuelRequestOrganizationByRequestCode = async (body) => await callApi(api.FUEL_REQUEST_ORGANIZATION_BY_REQUEST_CODE, body)

const operatorFuelRequestOrganizationHistory = async (body) => await callApi(api.OPERATOR_FUEL_REQUEST_ORGANIZATION_HISTORY, body)

const fuelRequestOrganizationVolumeReceived = async (body) => await callApi(api.FUEL_REQUEST_ORGANIZATION_VOLUME_RECEIVED, body)

const operatorDuelRequestOrganizationInprocess = async (body) => await callApi(api.OPERATOR_FUEL_REQUEST_ORGANIZATION_INPROCESS, body)

export {
    completeRequestOrganization,
    fuelRequestOrganizationByRequestCode,
    fuelRequestOrganizationVolumeReceived,
    operatorFuelRequestOrganizationHistory,
    operatorDuelRequestOrganizationInprocess,
}